module.exports = __webpack_public_path__ + "static/img/man.4c343b75.png";